import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'

import titleMixin from './mixins/titleMixin'

createApp(App)
  .use(i18n)
  .use(store)
  .use(router)
  .mixin(titleMixin)
  .mount('#app')
